import { render } from "./New293Form.vue?vue&type=template&id=5a87844e"
import script from "./New293Form.vue?vue&type=script&lang=js"
export * from "./New293Form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__